import { render, staticRenderFns } from "./WsInfoFile.vue?vue&type=template&id=65beeec5&"
import script from "./WsInfoFile.vue?vue&type=script&lang=js&"
export * from "./WsInfoFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports